<!-- Tab "Skills" of /tutors/:id/setup — the host owns the tutor menu and the card. -->
<div [nbSpinner]="loading || saving">
<section class="tile-flat" *ngIf="enabledSetting">
  <header class="tile-flat__header">
    <h5>{{ "pages.learnings.settingsTitle" | translate }}</h5>
  </header>
  <app-tutor-settings [tutorSetting]="enabledSetting" [tutor]="tutor"></app-tutor-settings>
  <app-tutor-settings *ngIf="maxLoadedSetting && featureEnabled" [tutorSetting]="maxLoadedSetting" [tutor]="tutor"></app-tutor-settings>
  <p class="hint warn" *ngIf="!featureEnabled">{{ "pages.skills.agent.disabledHint" | translate }}</p>
</section>

<section class="tile-flat">
  <header class="tile-flat__header">
    <h5>{{ "pages.skills.agent.listTitle" | translate }}</h5>
  </header>
  <p class="hint">
    {{ "pages.skills.agent.count" | translate: { count: assignedCount, max: maxPerAgent } }}
    <a *ngIf="canAssign" routerLink="/agent-setup/skills">{{ "pages.skills.agent.manage" | translate }}</a>
  </p>
  <p class="hint" *ngIf="!rows.length && !loading">
    {{ (canAssign ? "pages.skills.agent.noneAtClient" : "pages.skills.agent.noneAssigned") | translate }}
  </p>
  <ul class="skills">
    <li *ngFor="let row of rows; trackBy: trackRow">
      <div class="skill-head">
        <nb-checkbox *ngIf="canAssign" [checked]="row.assigned"
          [nbTooltip]="'pages.skills.tooltips.assign' | translate"
          (checkedChange)="toggleAssigned(row, $event)"></nb-checkbox>
        <strong>{{ row.skill.title || row.skill.name }}</strong>
        <span class="badge" [class.badge--on]="row.skill.is_active"
          [nbTooltip]="(row.skill.is_active ? 'pages.skills.tooltips.statusActive' : 'pages.skills.tooltips.statusInactive') | translate">
          {{ (row.skill.is_active ? "pages.skills.status.active" : "pages.skills.status.inactive") | translate }}
        </span>
      </div>
      <p class="hint">{{ row.skill.description }}</p>
    </li>
  </ul>
</section>
</div>
